module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/.6.11.6@babel-runtime/core-js/symbol/iterator.js
// module id = 87
// module chunks = 0